import jQuery from 'jquery';

import Animations from "./modules/Animations";
import Header from "./modules/Header";
import CapeBarba from "./modules/CapeBarba";
import InitJS from "./modules/InitJS";

require('bootstrap');
require('jquery-match-height');

window.$ = jQuery;
window.jQuery = jQuery;

(($) => {

    window.initJS = new InitJS();
    window.initJS.init();

    window.showLoader = () => {
        $('#loader-cape-container').addClass('show');
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        /* window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        }; */
    };

    window.hideLoader = (top) => {
        $('#loader-cape-container').removeClass('show');

        /* window.onscroll = function () {
            window.scrollTo();
        }; */

        if (top) {
            window.scrollTo(0, 0);
        }
    };

    new CapeBarba();
    new Animations();
    new Header();


    $(window).on('ajaxBeforeUpdate', () => {
        window.showLoader();
    });

    $(window).on('ajaxUpdateComplete', () => {
        window.initJS.init('october');
        window.hideLoader();
    });

    $(window).scroll(function (event) {
        $('.input-search').removeClass('show');

        let scroll = $(window).scrollTop();

        $('body').removeClass('scrolled');

        if(scroll > 40) {
            $('body').addClass('scrolled');
        }
    });

    $('#introduction-skip-button').on('click', () => {
       $('body').removeClass('introduction-open');

       setTimeout(() => {
           $('#introduction-player-container').remove();
       }, 500);
    });

    if(window.location.hash) {
        let hash = window.location.hash.substring(1);
        if(hash === 'newsletter-form') {
            MicroModal.show('popin-newsletter');
        }
    }

    const $menu = $('.input-search');

    $(document).mouseup(e => {
        if (!$menu.is(e.target)
            && $menu.has(e.target).length === 0)
        {
            $menu.removeClass('show');
        }
    });

    if ($('#homeModal').length) {
        $('#homeModal').modal('show');
    }

    $('.same-height>div').matchHeight();
})(jQuery);


const bannerCookie = document.querySelector('.gdpr-banner__button.gdpr-banner__button--opt-in')
const overlay = document.querySelector('.overlay-cookie')
const buttons = document.querySelectorAll('.gdpr-banner button')


window.onload = function() {
    if (bannerCookie) {
        overlay.classList.add('active')
    }
}

if (bannerCookie) {
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            overlay.classList.remove('active')
        })
    })
}
    

